// extracted by mini-css-extract-plugin
export default {"result":"PredictionDateCell_result__PuDj7","subTitle":"PredictionDateCell_subTitle__4kOi8"};